import autobind from 'react-autobind'
import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Switch from 'react-toggle-switch'

export default class NotificationListItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editTooltipOpen: false,
            deleteTooltipOpen: false,
            onOffSwitchTooltipOpen: false
        }
        autobind(this);
    }
    toggleEditTooltipOpen() {
        this.setState({
            editTooltipOpen: !this.state.editTooltipOpen
        })
    }

    toggleDeleteTooltipOpen() {
        this.setState({
            deleteTooltipOpen: !this.state.deleteTooltipOpen
        })
    }

    toggleOnOffSwitchTooltipOpen() {
        this.setState({
            onOffSwitchTooltipOpen: !this.state.onOffSwitchTooltipOpen
        })
    }

    render() {
        const { notification: { _id, locationName, address, picture, details, link, distance
            // , latitude, longitude 
        }, category, index } = this.props
        return (
            <div>
                <div className="items-list-item">
                    <div className="list-item-index">
                        {index}
                    </div>
                    <div className="list-item-1 list-item-product">
                        <div className="product-image-wrapper">
                            <img src={picture} className="product-image" alt="Location" />
                        </div>
                        <div className="product-details ellipsis">
                            <span className="name ellipsis">
                                {locationName}
                            </span>
                            <div className="small">{category}</div>
                            <span className="d-block ellipsis" title={address}>{address}</span>
                        </div>
                    </div>
                    <div className="list-item-2">
                        {distance}m
                    </div>
                    <div className="list-item-3">
                        <div className="ellipsis">
                            <span className="d-block ellipsis" title={details}>Details: {details}</span>
                            <span className="d-block ellipsis" title={link}>Link: {link}</span>
                        </div>
                    </div>
                    <div className="list-item-4 list-item-separator-left">
                        <span id={`onoffTooltip${_id}`}>
                            <Switch onClick={() => { this.props.onActiveSwitch(_id) }} on={this.props.active} className="switch-button switch-button-xs" />
                        </span>
                        <Tooltip placement="top" isOpen={this.state.onOffSwitchTooltipOpen} target={`onoffTooltip${_id}`} toggle={this.toggleOnOffSwitchTooltipOpen}>
                            Enable/Disable notification
                        </Tooltip>
                    </div>
                    <div className="list-item-5 list-item-actions">
                        <span className="ar-icon s7-edit mr-4" onClick={() => { this.props.editNotification(_id) }} id={`editTooltip${_id}`}></span>
                        <Tooltip placement="top" isOpen={this.state.editTooltipOpen} target={`editTooltip${_id}`} toggle={this.toggleEditTooltipOpen}>
                            Edit notification
                        </Tooltip>
                        <span className="ar-icon s7-trash" onClick={() => { this.props.deleteNotification(_id) }} id={`deleteTooltip${_id}`}></span>
                        <Tooltip placement="top" isOpen={this.state.deleteTooltipOpen} target={`deleteTooltip${_id}`} toggle={this.toggleDeleteTooltipOpen}>
                            Delete notification
                        </Tooltip>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Notification/NotificationListItem.js